export enum RevenueType {
  MERCHANT,
  CONTRACT_PPA,
  COMBINE
}

export enum UserAdministrationSection {
  USER_PROFILE,
  API_KEY_MANAGEMENT,
  ADMINISTRATION
}
